import { render, staticRenderFns } from "./TabelaDeContasAPagar.vue?vue&type=template&id=1ddcce4a&scoped=true"
import script from "./TabelaDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeContasAPagar.vue?vue&type=style&index=0&id=1ddcce4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcce4a",
  null
  
)

export default component.exports